import { render, staticRenderFns } from "./TurnList.vue?vue&type=template&id=93ab8294&scoped=true&"
import script from "./TurnList.vue?vue&type=script&lang=js&"
export * from "./TurnList.vue?vue&type=script&lang=js&"
import style0 from "./TurnList.vue?vue&type=style&index=0&id=93ab8294&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93ab8294",
  null
  
)

export default component.exports